import { render } from "./ConfirmationScreen.vue?vue&type=template&id=85bfd29e"
import script from "./ConfirmationScreen.vue?vue&type=script&lang=js"
export * from "./ConfirmationScreen.vue?vue&type=script&lang=js"

import "./ConfirmationScreen.vue?vue&type=style&index=0&id=85bfd29e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ConfirmationScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85bfd29e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85bfd29e', __exports__)) {
    api.reload('85bfd29e', __exports__)
  }
  
  module.hot.accept("./ConfirmationScreen.vue?vue&type=template&id=85bfd29e", () => {
    api.rerender('85bfd29e', render)
  })

}


export default __exports__